// ============================================
// CARTSUM.JS - Footer del carrito (ACTUALIZADO)
// ✅ Botón "Ir a mi carrito" ahora navega a /cart
// ============================================

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CartSum.css";
import { formatAmount } from '../../utils/money';
import PromoCodeModal from './PromoCodeModal';

export default function CartSum({ subtotal = 0, total = 0, onClose }) {
  const navigate = useNavigate();
  const [promoOpen, setPromoOpen] = useState(false);

  const handleGoToCart = () => {
    onClose(); // Cierra el minicart
    navigate("/cart"); // Navega a la página de carrito
  };

  return (
    <div className="cart-sum-clean">
      
      {/* Subtotal */}
      <div className="total-row-clean">
        <span className="total-label-clean">Subtotal</span>
        <span className="total-value-clean">${formatAmount(subtotal)}</span>
      </div>

      {/* Total */}
      <div className="total-row-clean total-final-clean">
        <span className="total-label-clean">Total</span>
        <span className="total-value-clean">${formatAmount(total)}</span>
      </div>

      {/* Código promocional → abre popup central con backdrop blur */}
      <button
        type="button"
        className="promo-toggle-clean"
        onClick={() => setPromoOpen(true)}
      >
        <span>Código promocional</span>
        <span className="promo-icon-clean">+</span>
      </button>

      <PromoCodeModal isOpen={promoOpen} onClose={() => setPromoOpen(false)} />

      {/* Botón Ir a mi carrito → ahora navega a /cart */}
      <button 
        className="checkout-btn-clean"
        onClick={handleGoToCart}
        disabled={total === 0}
      >
        Ir a mi carrito
      </button>

      {/* Continuar explorando */}
      <button 
        className="continue-shopping-clean"
        onClick={onClose}
      >
        continuar explorando
      </button>

      {/* Payment icons */}
      <div className="payment-icons-clean">
        <span className="payment-icon">VISA</span>
        <span className="payment-icon">●●</span>
        <span className="payment-icon">AMEX</span>
        <span className="payment-icon">PayPal</span>
      </div>
    </div>
  );
}
